import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { SpecialTool, SpecialToolType } from '../business-entities/special-tool-model';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class SpecialToolDataService {
    constructor(private dataProvider: DataService) {
    }

    async getSpecialToolList(vehicalObj:any): Promise<GenericResponse<Array<SpecialTool>>> {
        return this.dataProvider.Post<GenericResponse<Array<SpecialTool>>>(Urls.GetSpecialToolList,vehicalObj)
        .toPromise();
    }

    deleteSpecialTool(specialToolId:number){
        return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteSpecialTool,specialToolId)
        .toPromise();
    }

    async getSpecialToolById(specialToolId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
        (Urls.GetSpecialTool, specialToolId).toPromise();
    }

    async addEditSpecialTool(model : any) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddEditSpecialToolList, model).toPromise();
    }

    async getAllSpecialToolTypes(): Promise<GenericResponse<Array<SpecialToolType>>> {
      return this.dataProvider.Get<GenericResponse<Array<SpecialToolType>>>(Urls.GetAllSpecialToolType)
      .toPromise();
    }

}
